import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { set, get } from '@ember/object';

export default Route.extend({
  navbarSettings: service(),

  model(params) {
    let entityDetails = this.modelFor('organization.donors.donor');
    set(this, 'navbarSettings.title', get(entityDetails, 'entity.name'));
    let record = get(entityDetails, 'pledges').find(
      (x) => get(x, 'id') === params.pledgeId,
    );
    return {
      record,
    };
  },
});
